import React from "react";

const SearchIcon = ({ isActive }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const fillColor = isActive ? "var(--color-primary)" : isHovered ? "var(--color-primary)" : "#969BA9";

  return (
    <span onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="27" height="25" viewBox="0 0 27 27" fill="none">
        {<rect width="27" height="25" rx="5" fill={isActive ? "" : ""} />}
        <path
          d="M12.1963 18.3365C13.4834 18.3365 14.7337 17.9071 15.7491 17.1162L19.58 20.9471C19.8661 21.2234 20.3221 21.2155 20.5985 20.9293C20.8681 20.6502 20.8681 20.2076 20.5985 19.9285L16.7677 16.0976C18.7302 13.5713 18.2732 9.93236 15.7469 7.96981C13.2206 6.00727 9.58165 6.46428 7.61911 8.9906C5.65656 11.5169 6.11357 15.1559 8.63989 17.1184C9.65697 17.9085 10.9084 18.3371 12.1963 18.3365ZM9.11824 9.46674C10.8182 7.76672 13.5744 7.76669 15.2745 9.46667C16.9745 11.1667 16.9745 13.9229 15.2745 15.6229C13.5745 17.3229 10.8183 17.3229 9.11831 15.623C9.11828 15.6229 9.11828 15.6229 9.11824 15.6229C7.41826 13.9353 7.40825 11.1891 9.09584 9.48914C9.1033 9.48165 9.11076 9.47419 9.11824 9.46674Z"
          fill={fillColor}
        />
      </svg>
    </span>
  );
};

export default SearchIcon;
